import React from "react";
import styles from "./loader.module.scss";
import { Spinner } from "@fluentui/react-components";
import classNames from "classnames";

interface LoaderProps {
    text?: string;
    additionalClassName?: string;
}

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
    return (
        <div className={classNames(styles.wrapper, props.additionalClassName)}>
            <Spinner label={props.text} />
        </div>
    );
};

export default Loader;
